import {Controller} from '@hotwired/stimulus';

/* stimulusFetch: 'lazy' */
export default class extends Controller {
    static outlets = [
        'decline-booking-modal',
    ];

    static values = {
        bookingId: Number,
    };

    openModal(event) {
        if (event) {
            event.preventDefault();
        }

        this.declineBookingModalOutlet.bookingIdValue = this.bookingIdValue;
        this.declineBookingModalOutlet.showContent();
    }
}
